import React, { useCallback } from 'react'
import cn from 'classnames'
import Menu from '@groovehq/internal-design-system/lib/components/Dropdown/DropdownMenu'
import {
  indicator,
  text,
  paragraph,
} from '@groovehq/internal-design-system/lib/styles/elements'
import { SVGIcon } from 'shared/ui'
import presenceTypes from '../presenceTypes'
import { styles } from './styles'

const PresenceDropdownItem = React.memo(props => {
  const { presence, className, onClick, ...rest } = props
  const {
    name = 'Unknown',
    description = '',
    className: presenceClassName = '',
  } =
    presenceTypes[presence] || {}

  const handleClick = useCallback(
    () => {
      if (onClick) onClick(presence)
    },
    [onClick, presence]
  )

  return (
    <Menu.Item
      className={cn(className, presenceClassName)}
      aria-checked="false"
      onClick={handleClick}
      {...rest}
    >
      {presence !== 'autoPresence' && (
        <span
          css={[
            indicator.styles.dot,
            indicator.statusBg[presenceClassName],
            styles.statusDot,
          ]}
        />
      )}
      {presence === 'autoPresence' && (
        <SVGIcon name="sync" size={12} css={styles.svgStatusDot} />
      )}
      <div>
        <span css={[text.styles.textXs, text.styles.fontSemibold]}>{name}</span>
        <p
          css={[
            paragraph.styles.preflight,
            text.styles.text2Xs,
            text.styles.textDark,
          ]}
        >
          {description}
        </p>
      </div>
    </Menu.Item>
  )
})

export default PresenceDropdownItem
